import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';

import { INavDropdown } from './nav.dropdown.interface';

@Component({
    selector: 'mlp-ng-nav-dropdown',
    templateUrl: './nav.dropdown.component.html',
    styleUrls: ['./nav.dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class NavDropdownSharedComponent implements OnDestroy {
    @Input() link: INavDropdown;

    toggle(): void {
        this.link['open'] = (this.link['open']) ? false : true;
    }

    closeDropdown(): void {
        this.link['open'] = false;
    }

    ngOnDestroy(): void {
        this.link['open'] = false;
    }
}
